function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlatbedTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2227 867",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1719.53,729.642l-507.36,0l-0,-655.823c-0,-40.769 33.049,-73.819 73.819,-73.819l344.464,0c39.466,-0 77.289,15.801 105.027,43.877l246.991,250.185c59.572,60.343 193.705,92.968 193.705,92.968c30.266,9.974 50.715,38.243 50.715,70.11l-0,235.593c-0,9.789 -3.889,19.177 -10.811,26.099c-6.922,6.922 -16.31,10.81 -26.099,10.81l-130.781,0c-0,-93.734 -76.101,-169.834 -169.835,-169.834c-93.735,-0 -169.835,76.1 -169.835,169.834Zm-102.97,-633.713l-274.931,-0c-20.385,-0 -36.91,16.525 -36.91,36.909l0,87.411c0,61.153 49.575,110.728 110.728,110.728l437.664,-0c4.466,-0 8.495,-2.683 10.217,-6.805c1.722,-4.121 0.799,-8.873 -2.34,-12.05l-191.914,-194.255c-13.869,-14.037 -32.78,-21.938 -52.514,-21.938Zm-1450.97,633.713l-128.686,0c-9.789,0 -19.177,-3.888 -26.098,-10.81c-6.922,-6.922 -10.811,-16.31 -10.811,-26.099l0,-75.8c-0,-9.789 3.889,-19.177 10.811,-26.099c6.921,-6.922 16.309,-10.811 26.098,-10.811l218.14,0c-53.238,28.685 -89.454,84.956 -89.454,149.619Zm250.215,-149.619l772.022,0l0,149.619l-682.568,0c0,-64.663 -36.216,-120.934 -89.454,-149.619Zm1473.56,12.556c75.647,0 137.063,61.416 137.063,137.063c0,75.647 -61.416,137.063 -137.063,137.063c-75.647,0 -137.063,-61.416 -137.063,-137.063c-0,-75.647 61.416,-137.063 137.063,-137.063Zm-1553.94,0c75.647,0 137.063,61.416 137.063,137.063c-0,75.647 -61.416,137.063 -137.063,137.063c-75.648,0 -137.064,-61.416 -137.064,-137.063c0,-75.647 61.416,-137.063 137.064,-137.063Z",
    style: {
      fill: "#141f2a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatbedTruck);
export default __webpack_public_path__ + "static/media/FlatbedTruck.a4ddf3833e1effd9562e78a4161e85cb.svg";
export { ForwardRef as ReactComponent };